













































import Vue from 'vue';
import LabelMixin from '@/mixins/labelMixin';

export default Vue.extend({
  mixins: [LabelMixin],
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    max: {
      type: Number,
      default: null,
    },
    min: {
      type: Number,
      default: null,
    },
    adminFee: {
      type: Number,
      default: null,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    displayFee: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      donationAmount: this.value,
      hideFee: true
    };
  },
  computed: {
    totalAmountCalculated(): number | null {
      const donationAmount: number = parseFloat(this.donationAmount);
      if (
        this.min <= donationAmount &&
        donationAmount <= this.max
      ) {
        return donationAmount + this.adminFee;
      }
      return null;
    },
  },
  watch: {
    donationAmount(value) {
      this.$emit('input', value);
    },
    adminFee() {
      this.hideFee = !this.adminFee || this.adminFee === 0 || !this.displayFee
    },
    displayFee() {
      this.hideFee = !this.adminFee || this.adminFee === 0 || !this.displayFee
    },
    value(newVal) {
      this.donationAmount = newVal;
    }
  },
  mounted(){
    this.hideFee = !this.adminFee || this.adminFee === 0 || !this.displayFee;
  },
});
